import { render, staticRenderFns } from "./CheckBoxRenderer.vue?vue&type=template&id=d639acc4&"
import script from "./CheckBoxRenderer.vue?vue&type=script&lang=ts&"
export * from "./CheckBoxRenderer.vue?vue&type=script&lang=ts&"
import style0 from "./CheckBoxRenderer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports